import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Employee } from '..';
import { EmployeeSkillsCard } from '../../../pages/Skills';

type Props = {
  employee: Employee;
};

export const EmployeeSkills: React.FC<React.PropsWithChildren<Props>> = ({
  employee,
}) => {
  return (
    <Row>
      <Col md={8} lg={6} xl={4}>
        <EmployeeSkillsCard
          employeeId={employee.Id}
          employeeName={employee.Name}
        />
      </Col>
    </Row>
  );
};
